(function () {
    'use strict';
    realmCommerceApp.config(config);

    /*@ngInject*/
    function config(noCAPTCHAProvider) {
        /**
         * TODO: Replace the google site key with the key for production.
         */
        noCAPTCHAProvider.setSiteKey('6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI');
        noCAPTCHAProvider.setTheme('light');
    }
})();


// WEBPACK FOOTER //
// ./static/js/app/config/nocaptcha.config.js